import React from 'react'
import Helmet from 'react-helmet'

import { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { SEO } from './config'
import { HeroSection } from './sections/HeroSection'
import { FoodBoxHowItWorksSection } from './sections/FoodBoxHowItWorksSection'
import { BenefitsOfGoustoSection } from './sections/BenefitsOfGoustoSection'
import { TestimonialSection } from '../../sections'
import { Box, Color } from '@gousto-internal/citrus-react'
import { WhatsFoodBox } from './sections/WhatsFoodBox'
import { FoodBoxFAQSection } from './sections/FoodBoxFAQSection'
import { GiveGoustoAGoSection } from './sections/GiveGoustoAGoSection/GiveGoustoAGoSection'
import { FoodBoxCarousel } from './sections/FoodBoxCarouselSection/FoodBoxCarousel'
import { WhatsInsideSection } from './sections/WhatsInsideSection'

export function FoodBoxPage({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <>
      <Helmet title={SEO.head.title} meta={SEO.head.meta}>
        <meta property="og:title" content={SEO.head.title} />
        <meta property="og:description" content={SEO.head.meta[0].content} />
      </Helmet>
      <HeroSection startOnboarding={startOnboarding} />
      <WhatsFoodBox startOnboarding={startOnboarding} />
      <FoodBoxCarousel startOnboarding={startOnboarding} />
      <WhatsInsideSection startOnboarding={startOnboarding} />
      <FoodBoxHowItWorksSection startOnboarding={startOnboarding} />
      <BenefitsOfGoustoSection startOnboarding={startOnboarding} />
      <Box bg={Color.NeutralGrey_50}>
        <TestimonialSection />
      </Box>
      <FoodBoxFAQSection startOnboarding={startOnboarding} />
      <GiveGoustoAGoSection startOnboarding={startOnboarding} />
    </>
  )
}
